<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p>
<div class="ctag1">Also by Henning Mankell<br/>
</div>
<div class="ctag1">THE KURT WALLANDER MYSTERY SERIES
<br/><br/>
<i>Faceless Killers</i>
<br/><br/>
<i>The Dogs of Riga</i>
<br/><br/>
<i>The White Lioness</i>
<br/><br/>
<i>The Man Who Smiled</i>
<br/><br/>
<i>Sidetracked</i>
<br/><br/>
<i>The Fifth Woman</i>
<br/><br/>
<i>One Step Behind</i>
<br/><br/>
<i>The Pyramid</i>
<br/><br/>
<i>The Troubled Man</i>
<br/><br/><br/><br/>
<i>The Return of the Dancing Master</i>
<br/><br/>
<i>Before the Frost: A Linda Wallander Mystery</i>
<br/><br/>
<i>I Die, But My Memory Lives On:</i>
<br/><br/>
<i>The World AIDS Crisis and the Memory Book Project</i>
<br/><br/>
<i>Chronicler of the Winds</i>
<br/><br/>
<i>Depths</i>
<br/><br/>
<i>Kennedy’s Brain</i>
<br/><br/>
<i>The Eye of the Leopard</i>
<br/><br/>
<i>Italian Shoes</i>
<br/><br/>
<i>The Man from Beijing</i>
<br/><br/>
<i>Daniel</i>
<br/><br/>
<i>The Shadow Girls</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// henn_9781595586124_oeb_fm1_r1.vue?7c16aafc